import { useState } from "react";
import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import { CsmText } from "../../../library/components/mui/CsmText";
import { Button } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import { HesapBilgiVeKullaniciModel } from "../../../models/businessModels/HesapBilgiVeKullaniciModel";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import { CsmSwipableListItem } from "../../../library/components/mui/CsmSwipableListItem";
import SesGrupluKisiAvatarListControl from "../../../components/business/SesGrupluKisiAvatarListControl";
import { SarkiModel } from "../../../models/businessModels/SarkiModel";
import { HesapSarkiSesKayitModel } from "../../../models/businessModels/HesapSarkiSesKayitModel";
import { HesapKuartetModel } from "../../../models/businessModels/HesapKuartetModel";
import AlertHelper from "../../../library/helpers/AlertHelper";
import { HesapKuartetListDurumGuncelleRequestModel } from "../../../models/requestModels/HesapKuartetListDurumGuncelleRequestModel";
import { HesapKuartetDurumGuncelleRequestModel } from "../../../models/requestModels/HesapKuartetDurumGuncelleRequestModel";
import JsonHelper from "../../../library/helpers/JsonHelper";
import { GuidHelper } from "../../../library/helpers/GuidHelper";
import appColors from "../../../app/appColors";
import { ColorCalculationHelper } from "../../../library/helpers/ColorCalculationHelper";

interface IKuartetSarkiPopupEditorProps {
    sarki: SarkiModel,
    kayitlar: HesapSarkiSesKayitModel[],
    kuartetler: HesapKuartetModel[],
    hesaplar: HesapBilgiVeKullaniciModel[],
    genelDurumHelper: GenelDurumHelper,
    closer: (response: HesapKuartetModel[] | null) => void,
}

function KuartetSarkiPopupEditor(props: IKuartetSarkiPopupEditorProps) {
    const { closer, genelDurumHelper } = props;

    const [kuartetBasariliOlanlar, setKuartetBasariliOlanlar] = useState<string[]>([]);
    const [kuartetBasarisizOlanlar, setKuartetBasarisizOlanlar] = useState<string[]>([]);
    const [kuartetYapmayanlar, setKuartetYapmayanlar] = useState<string[]>([]);


    const kuartetDurumGuncelle = async (sarki: SarkiModel, hesap: HesapBilgiVeKullaniciModel, sonDurum: boolean | null) => {
        const buttonTexts = ["Başarılı", "Başarısız", "Kuartet Yapmadı"];
        if (sonDurum === null)
            buttonTexts.remove("Kuartet Yapmadı");
        else if (sonDurum === true)
            buttonTexts.remove("Başarılı");
        else
            buttonTexts.remove("Başarısız");

        const confirmResult = await AlertHelper.ConfirmWithChoices(
            "Kuartet Sonucu",
            `${hesap.kullaniciModel.ad} ${hesap.kullaniciModel.soyad} isimli kişinin ${sarki.isim} eseri Kuartet sonucunu seçiniz`,
            buttonTexts
        );

        if (confirmResult == null)
            return;

        const result = confirmResult as string;

        const _kuartetBasariliOlanlar = kuartetBasariliOlanlar.slice();
        const _kuartetBasarisizOlanlar = kuartetBasarisizOlanlar.slice();
        const _kuartetYapmayanlar = kuartetYapmayanlar.slice();

        if (_kuartetBasariliOlanlar.contains(hesap.id))
            _kuartetBasariliOlanlar.remove(hesap.id);
        if (_kuartetBasarisizOlanlar.contains(hesap.id))
            _kuartetBasarisizOlanlar.remove(hesap.id);
        if (_kuartetYapmayanlar.contains(hesap.id))
            _kuartetYapmayanlar.remove(hesap.id);

        if (result === "Başarılı")
            _kuartetBasariliOlanlar.push(hesap.id);
        else if (result === "Başarısız")
            _kuartetBasarisizOlanlar.push(hesap.id);
        else //if (result === "Kuartet Yapmadı")
            _kuartetYapmayanlar.push(hesap.id);

        setKuartetBasariliOlanlar(_kuartetBasariliOlanlar);
        setKuartetBasarisizOlanlar(_kuartetBasarisizOlanlar);
        setKuartetYapmayanlar(_kuartetYapmayanlar);
    }

    const kuartetleriGercektenBildir = async () => {

        const modelToSend = new HesapKuartetListDurumGuncelleRequestModel([]);
        const kuartetResults: { hesapId: string, durum: boolean | null }[] = [];

        for (const hesapId of kuartetBasariliOlanlar)
            kuartetResults.push({ hesapId: hesapId, durum: true });
        for (const hesapId of kuartetBasarisizOlanlar)
            kuartetResults.push({ hesapId: hesapId, durum: false });
        for (const hesapId of kuartetYapmayanlar)
            kuartetResults.push({ hesapId: hesapId, durum: null });

        for (const kuartetResult of kuartetResults)
            modelToSend.kuartetler.push(new HesapKuartetDurumGuncelleRequestModel(props.sarki.id, kuartetResult.hesapId, kuartetResult.durum));


        const webResponse = await genelDurumHelper.requestHelper.YonetimHesapMuzikal.HesapKuartetListDurumGuncelle(modelToSend);
        if (!webResponse.successfull)
            return;

        const result = JsonHelper.deepCopy(props.kuartetler);

        for (const kuartetteBasariliOlan of kuartetBasariliOlanlar) {
            const found = result.singleOrDefault(e => e.hesapModelId === kuartetteBasariliOlan && e.sarkiModelId === props.sarki.id);
            if (found == null) {
                const modelToAdd = new HesapKuartetModel();
                modelToAdd.id = GuidHelper.NewGuid();
                modelToAdd.hesapModelId = kuartetteBasariliOlan;
                modelToAdd.sarkiModelId = props.sarki.id;
                modelToAdd.tarih = new Date();
                modelToAdd.kuartetBasarili = true;
                result.push(modelToAdd);
            }
            else
                found.kuartetBasarili = true;
        }

        for (const kuartetteBasarisizOlan of kuartetBasarisizOlanlar) {
            const found = result.singleOrDefault(e => e.hesapModelId === kuartetteBasarisizOlan && e.sarkiModelId === props.sarki.id);
            if (found == null) {
                const modelToAdd = new HesapKuartetModel();
                modelToAdd.id = GuidHelper.NewGuid();
                modelToAdd.hesapModelId = kuartetteBasarisizOlan;
                modelToAdd.sarkiModelId = props.sarki.id;
                modelToAdd.tarih = new Date();
                modelToAdd.kuartetBasarili = false;
                result.push(modelToAdd);
            }
            else
                found.kuartetBasarili = false;
        }

        for (const kuartetYapmayan of kuartetYapmayanlar) {
            const found = result.singleOrDefault(e => e.hesapModelId === kuartetYapmayan && e.sarkiModelId === props.sarki.id);
            if (found != null) {
                result.remove(found);
            }
        }

        closer(result);
    }

    function koristAktifSezonKuartetSayiGetir(hesap: HesapBilgiVeKullaniciModel) {
        const koro = genelDurumHelper.SeciliKoroModel;
        const donemSarkilari = koro.tumSarkilar.where(e => e.sezonSarkiModelList.any(t => t.sezonModelId === genelDurumHelper.AktifSezon.id)).select(e => e.id);
        const kuartetSarkilari = koro.hesapKuartetModelList.where(e => e.hesapModelId === hesap.id && e.kuartetBasarili === true).select(e => e.sarkiModelId).distinct();

        return donemSarkilari.intersection(kuartetSarkilari).length;
    }

    let kuartetYapmayanIcerik: JSX.Element[] | JSX.Element = <CsmSwipableListItem><CsmText note>Kuartet yapmayan kullanıcı bulunmamaktadır</CsmText></CsmSwipableListItem>;
    let kuartetHataliIcerik: JSX.Element[] | JSX.Element = <CsmSwipableListItem><CsmText note>Kuartet hatası olan kullanıcı bulunmamaktadır</CsmText></CsmSwipableListItem>;
    let kuartetYapanIcerik: JSX.Element[] | JSX.Element = <CsmSwipableListItem><CsmText note>Kuartet yapan kullanıcı bulunmamaktadır</CsmText></CsmSwipableListItem>;

    const tumKuartetler = props.kuartetler.where(e => e.sarkiModelId === props.sarki.id);

    const kuartetYapmayanKullanicilar: HesapBilgiVeKullaniciModel[] = [];
    const kuartetHataliKullanicilar: HesapBilgiVeKullaniciModel[] = [];
    const kuartetYapanKullanicilar: HesapBilgiVeKullaniciModel[] = [];

    const kullanicilar = props.hesaplar.where(e => e.aktif === true && !e.araVerdi && BusinessHelper.Genel.KoristMi(e));

    kullanicilar.forEach((hesap) => {
        const kuartet = tumKuartetler.singleOrDefault(e => e.hesapModelId === hesap.id);

        // ön listeye bak orda varsa, diğer kısmı sallama
        if (kuartetBasariliOlanlar.contains(hesap.id)) {
            kuartetYapanKullanicilar.push(hesap);
        }
        else if (kuartetBasarisizOlanlar.contains(hesap.id)) {
            kuartetHataliKullanicilar.push(hesap);
        }
        else if (kuartetYapmayanlar.contains(hesap.id)) {
            kuartetYapmayanKullanicilar.push(hesap);
        }
        else {

            // normal listeye bak
            if (kuartet == null) {
                kuartetYapmayanKullanicilar.push(hesap);
            }
            else if (kuartet.kuartetBasarili === true)
                kuartetYapanKullanicilar.push(hesap);
            else
                kuartetHataliKullanicilar.push(hesap);
        }
    });

    const kuartetYapmayanlarKuartetSayilari = kuartetYapmayanKullanicilar.select(e => ({ id: e.id, sayi: koristAktifSezonKuartetSayiGetir(e) }))
    const kuartetYapmayanlarKuartetSayilariDict = Object.fromEntries(kuartetYapmayanlarKuartetSayilari.select(e => [e.id, e.sayi]));

    const maxKuartet = kuartetYapmayanlarKuartetSayilari.max(e => e.sayi) ?? 0;
    const minKuartet = kuartetYapmayanlarKuartetSayilari.min(e => e.sayi) ?? 0;

    // Kuartet
    if (kuartetYapmayanKullanicilar.length > 0)
        kuartetYapmayanIcerik = (
            <SesGrupluKisiAvatarListControl
                tumHesaplar={genelDurumHelper.SeciliKoroModel.hesapBilgiList.where(e => e.aktif && BusinessHelper.Genel.KoristMi(e))}
                hesapIsimTextGetir={e => `${e.kullaniciModel.ad} ${e.kullaniciModel.soyad} (${kuartetYapmayanlarKuartetSayilariDict[e.id]})`}
                thumbnailSize="normal"
                hesapColorizeMethod="Custom"
                customHesapColorizeMethod={e =>
                    BusinessHelper.Konser.KoristKonserdeSarkiyiSoylemisMi(genelDurumHelper, e, props.sarki.id) ?
                        appColors.LIGHTGREEN :
                        ColorCalculationHelper.MinMaxRenkGetir_YellowToColor(kuartetYapmayanlarKuartetSayilariDict[e.id], minKuartet, maxKuartet)}
                gosterilecekHesaplar={kuartetYapmayanKullanicilar}
                sesGrupYontemOrSarki={props.sarki}
                onClick={(hesap) => kuartetDurumGuncelle(props.sarki, hesap, null)}
                genelDurumHelper={genelDurumHelper} />
        );

    if (kuartetHataliKullanicilar.length > 0) {
        kuartetHataliIcerik = (
            <SesGrupluKisiAvatarListControl
                tumHesaplar={genelDurumHelper.SeciliKoroModel.hesapBilgiList.where(e => e.aktif && BusinessHelper.Genel.KoristMi(e))}
                thumbnailSize="normal"
                gosterilecekHesaplar={kuartetHataliKullanicilar}
                sesGrupYontemOrSarki={props.sarki}
                onClick={(hesap) => kuartetDurumGuncelle(props.sarki, hesap, false)}
                genelDurumHelper={genelDurumHelper} />
        );
    }
    if (kuartetYapanKullanicilar.length > 0) {
        kuartetYapanIcerik = (
            <SesGrupluKisiAvatarListControl
                tumHesaplar={genelDurumHelper.SeciliKoroModel.hesapBilgiList.where(e => e.aktif && BusinessHelper.Genel.KoristMi(e))}
                gosterilecekHesaplar={kuartetYapanKullanicilar}
                sesGrupYontemOrSarki={props.sarki}
                onClick={(hesap) => kuartetDurumGuncelle(props.sarki, hesap, true)}
                genelDurumHelper={genelDurumHelper} />
        );
    }

    return (
        <Rows height={550} style={{ minWidth: 890 }}>
            <Rows flex>
                <CsmSwipableListItem itemDividerText="Kuartet Yapmayanlar" />
                {kuartetYapmayanIcerik}
                <CsmSwipableListItem itemDividerText="Kuartet Hatası Olanlar" />
                {kuartetHataliIcerik}
                <CsmSwipableListItem itemDividerText="Kuartet Yapanlar" />
                {kuartetYapanIcerik}
            </Rows>
            <Columns height={60} mt={10}>
                <Button color="error" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginLeft: 0 }}>
                    {appIcons.Popup.iptal}
                    {genelDurumHelper.translate("İptal")}</Button>
                <Button color="success" variant="contained" onClick={() => kuartetleriGercektenBildir()} disabled={!(kuartetBasariliOlanlar.length > 0 || kuartetBasarisizOlanlar.length > 0 || kuartetYapmayanlar.length > 0)} style={{ flex: 1, margin: 10, marginRight: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Kaydet")}</Button>
            </Columns>
        </Rows >
    );


}

export default KuartetSarkiPopupEditor;